export default __webpack_public_path__ + "static/media/chevron-down.baab05ad.svg";